import type { HelpCenterCategoryWidgetState } from './types';

export const defaultState: HelpCenterCategoryWidgetState = {
  categoriesList: [],
  categoryArticles: [],
  pageSize: '10',

  isLoading: true,
  preloaded: false,
  error: false
};
